export default [
    {
        path: '/platinum/redirect',
        props: true,
        component: () => import('@/views/PlatinumRedirect'),
    },
];
